import React from "react";
import { twMerge } from "tailwind-merge";

interface LatestFinancialHeaderProps {
  header: string;
  description: string;
  customClass?: string;
}

const LatestFinancialHeader = ({ header, description, customClass }: LatestFinancialHeaderProps) => {
  return (
    <div className={twMerge("flex flex-col gap-1", customClass)}>
        <h2 className="md:text-[20px] text-[18px] font-medium text-[#1a1a1a]">{header}</h2>
      <p className="text-[12px] text-[#666666]">{description}</p>
    </div>
  );
};

export default LatestFinancialHeader;